<template>
  <div class="col-lg-10 col-md-10">
    <center-header :selected-menu-item="5" />
    <div class="tab-content">
      <div class="tab-pane active">
        <ExportLogic
          :panel-title="trans('general.pageTitleEvaluations')"
          :export-url="'/api/internal/center-admin/export'"
          role="center_admin"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CenterHeader from "../CenterHeader.vue";
import ExportLogic from "../../../app/practitioner-portal/generic/export/ExportLogic.vue";
export default {
  components: {
    CenterHeader,
    ExportLogic,
  },
};
</script>
